import React, { Component, Fragment } from 'react'

import { ResidentialCalculator, CommercialCalculator } from './Calculators'

import Form from './Form'

const minStage = 1
const maxStage = 4

// Clamp stage to within min/max stage.
function clampStage (stage) {
  return Math.max(
    minStage,
    Math.min(
      maxStage,
      stage
    )
  )
}

export default class App extends Component {
  state = {
    mode: 'residential',

    data: {
      residential: {
        stage: 1,
        unit: 'metric',

        netLandArea: null,

        unitCountPrivate: null,
        unitSizePrivate: null,
        salesValuePrivate: null,

        unitCountAffordable: null,
        unitSizeAffordable: null,
        salesValueAffordable: null,

        baseBuildCost: null,

        developmentContingency: {
          value: null,
          unit: 'percent'
        },
        constructionAbnormals: null,
        externals: {
          value: null,
          unit: 'percent'
        },
        professionalFees: {
          value: null,
          unit: 'percent'
        },
        salesAndMarketing: {
          value: null,
          unit: 'percent'
        },
        legalFeesPerUnit: null,
        finance: {
          value: null,
          unit: 'percent'
        },

        profit: {
          value: null,
          unit: 'percentgdv'
        },

        legalSiteAcquisitionCost: null,
        planning: null,
        surveys: null,
      },
      commercial: {
        unit: 'metric',
        stage: 1,

        totalLandArea: null,
        netLandArea: null,
        rentValue: null,
        initialYield: null,
        purchasersCosts: {
          value: null,
          unit: 'percent'
        },

        baseBuildCost: null,

        developmentContingency: {
          value: null,
          unit: 'percent'
        },
        externals: {
          value: null,
          unit: 'percent'
        },
        professionalFees: {
          value: null,
          unit: 'percent'
        },
        lettingAgentFees: {
          value: null,
          unit: 'percent'
        },
        legalLettingFees: {
          value: null,
          unit: 'percent'
        },
        salesAgentFees: {
          value: null,
          unit: 'percent'
        },
        legalSalesFees: {
          value: null,
          unit: 'percent'
        },
        finance: {
          value: null,
          unit: 'percent'
        },

        profit: {
          value: null,
          unit: 'percentcost'
        },

        legalSiteAcquisitionCost: null,
        planning: null,
        surveys: null,
      },
    },
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mode !== this.state.mode ||
      prevState.data[this.state.mode].stage !== this.state.data[this.state.mode].stage
    ) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  switchToResidential = () => this.setState({ mode: 'residential' })
  switchToCommercial = () => this.setState({ mode: 'commercial' })

  gotoPreviousStage = () => this.gotoStage(this.state.data[this.state.mode].stage - 1)
  gotoNextStage = () => this.gotoStage(this.state.data[this.state.mode].stage + 1)

  gotoStage = (stage) => this.setState({
    data: {
      ...this.state.data,
      [this.state.mode]: {
        ...this.state.data[this.state.mode],
        stage: clampStage(stage),
      },
    },
  })

  getCalculator (mode, data) {
    if (mode === 'residential') {
      return new ResidentialCalculator(data[mode])
    } else if (mode === 'commercial') {
      return new CommercialCalculator(data[mode])
    }
  }

  handleUpdateUnit = (unit) => {
    this.setState((state) => {
      const { data, mode } = state

      const calculator = this.getCalculator(mode, data)

      return {
        data: {
          ...data,
          [mode]: {
            stage: data[mode].stage,
            ...calculator.translateToUnit(unit),
          },
        },
      }
    })
  }

  handleUpdateField = (field, value) => this.setState({
    data: {
      ...this.state.data,
      [this.state.mode]: {
        ...this.state.data[this.state.mode],
        [field]: value,
      },
    },
  })

  render() {
    const { data, mode } = this.state

    const calculator = this.getCalculator(mode, data)
    window.calc = calculator

    return (
      <Fragment>
        <img src='/img/logo.png' className='print-logo' alt='Land Attic' />
        <div className='tabs tabs--borderless'>
          <div className='tabs__nav'>
            <button
              className={`tab__label ${mode === 'residential' ? 'tab__label--active' : ''}`}
              onClick={this.switchToResidential}
            >
              Residential
            </button>
            <button
              className={`tab__label ${mode === 'commercial' ? 'tab__label--active' : ''}`}
              onClick={this.switchToCommercial}
            >
              Commercial
            </button>
          </div>
          <div className='tabs__panels'>
            <div className='tab__panel tab__panel--padded tab__panel--active'>
              <Form
                calculator={calculator}
                data={data[mode]}
                gotoNextStage={this.gotoNextStage}
                gotoPreviousStage={this.gotoPreviousStage}
                gotoStage={this.gotoStage}
                mode={mode}
                stage={data[mode].stage}
                updateField={this.handleUpdateField}
                updateUnit={this.handleUpdateUnit}
              />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
